import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SidebarModule } from 'ng-sidebar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { VerifyComponent } from './auth/verify/verify.component';
import { VerifiedComponent } from './auth/verified/verified.component';
import { ReverifyComponent } from './auth/reverify/reverify.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ForgotPasswordComponent } from './auth/forgot-password/reverify-forgot-password.component';
import { StatusComponent } from './auth/status/status.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { GoogleCallbackComponent } from './auth/google/callback/callback.component';
import { AuthenticateComponent as GoogleAuthenticateComponent } from './auth/google/authenticate/authenticate.component';
import { CallbackComponent as FacebookCallbackComponent } from './auth/facebook/callback/callback.component';
import { AuthenticateComponent as FacebookAuthenticateComponent } from './auth/facebook/authenticate/authenticate.component';
import { AuthenticateComponent as TwitterAuthenciateComponent } from './auth/twitter/authenticate/authenticate.component';
import { CallbackComponent as TwitterCallbackComponent } from './auth/twitter/callback/callback.component';
import { AuthenticateComponent as LinkedinAuthenticateComponent } from './auth/linkedin/authenticate/authenticate.component';
import { CallbackComponent as LinkedinCallbackComponent } from './auth/linkedin/callback/callback.component';
import { ToastsContainerComponent } from './toasts-container/toasts-container.component';

// import { ToastsContainerComponent } from './toasts-container/toasts-container.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    VerifyComponent,
    VerifiedComponent,
    ReverifyComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    NotFoundComponent,
    StatusComponent,
    LogoutComponent,
    GoogleAuthenticateComponent,
    GoogleCallbackComponent,
    FacebookAuthenticateComponent,
    FacebookCallbackComponent,
    TwitterAuthenciateComponent,
    TwitterCallbackComponent,
    LinkedinAuthenticateComponent,
    LinkedinCallbackComponent,
    ToastsContainerComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    SidebarModule,
    HttpClientModule,
    NgbModule
  ],
  providers: [],
  bootstrap: [AppComponent, ToastsContainerComponent]
})
export class AppModule { }
